import { jsx as _jsx } from "react/jsx-runtime";
import { VolunteerServiceProvider } from '../../volunteer-service/rest/VolunteerServiceProvider';
import PhraseProvider from '../../phrase/PhraseProvider';
import RegisterAssignment from './RegisterAssignment';
import './App.scss';
function App({ volunteerApiUri, volunteerAppSecret, labels }) {
    return (_jsx(PhraseProvider, Object.assign({ phrases: labels !== null && labels !== void 0 ? labels : {} }, { children: _jsx(VolunteerServiceProvider, Object.assign({ uri: volunteerApiUri, appSecret: volunteerAppSecret }, { children: _jsx("div", Object.assign({ className: "assignment-form-app" }, { children: _jsx(RegisterAssignment, {}) })) })) })));
}
export default App;
